import { render } from "./index.vue?vue&type=template&id=b5f32bae"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=b5f32bae&lang=scss"

import exportComponent from "/Users/tung/Documents/GitHub/cc-faq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__